// Mesure d'audience ANONYME (audit F10) : un compteur par jour et par type d'événement.
// Envoi sans cookie ni jeton de connexion, sans propriété individuelle ; aucune lecture du stockage
// du téléphone. N'échoue jamais côté interface.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const trackEvent = (name) => {
  try {
    fetch(`${BACKEND_URL}/api/analytics/event`, {
      method: "POST",
      credentials: "omit",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ name }),
      keepalive: true,
    }).catch(() => {});
  } catch (e) { /* noop */ }
};
